// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__+hRhb","closeAndContentWrapper":"Modal_closeAndContentWrapper__bw4l1","close":"Modal_close__TkiLF","paper":"Modal_paper__sgP0I"};